import React, { useState } from "react";
import "./add-bank-account.scss";
import { GSForm, GSSidePanelPage } from "golfstatus_react_components";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import {
  selectCurrentOrganization,
  createOrganizationBankAccount,
  clearNotifications,
  selectOrganizationNotifications,
  setSelectedOrganizationBankAccount,
  selectOrganizationBankAccount
} from "../../reducers/organizationSlice";
import { getBankAccountForm } from "../../forms/BankAccountForm";
import { useFormValidation } from "../../hooks/formHooks";
import { useNotificationBanner, useNotificationNavigation } from "../../hooks/notificationHooks";

const AddBankAccount = () => {
  const [context, isValid, setIsValid] = useFormValidation(false);
  const [confirmedAccountNumber, setConfirmedAccountNumber] = useState("");
  const selectedBankAccount = useSelector(selectOrganizationBankAccount);
  const selectedOrganization = useSelector(selectCurrentOrganization);
  const orgNotifications = useSelector(selectOrganizationNotifications);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useNotificationNavigation("created", orgNotifications, `/${selectedOrganization.id}/settings/payments`);

  const createBankAccount = () => {
    if (isValidBankDetails()) {
        setIsValid(false);
        let bankAccount = { ...selectedBankAccount }
        bankAccount['organizationId'] = selectedOrganization.id;
        dispatch(createOrganizationBankAccount(bankAccount));
    }
  }

  context.updateBankAccount = (value, property) => {
    setIsValid(true);
    let bankAccount = { ...selectedBankAccount };
    bankAccount[property] = value;
    return dispatch(setSelectedOrganizationBankAccount(bankAccount));
  };

  context.validationFailed = () => {
    if (isValid) {
      setIsValid(false);
    }
  };

  context.confirmedAccountNumber = confirmedAccountNumber;
  context.setConfirmedAccountNumber = setConfirmedAccountNumber;
  context.setIsValid = setIsValid;
  
  const isValidBankDetails = () => {
    let bankAccount = selectedBankAccount || {};
    return bankAccount?.accountNumber && bankAccount?.routingNumber && bankAccount?.accountType && confirmedAccountNumber === bankAccount?.accountNumber;
  };

  const leftNavigation = () => {
    dispatch(clearNotifications());
    navigate(-1);
  };

  const getActions = () => {
    let actions = [
      {
        name: "save",
        action: createBankAccount,
        isDisabled: !isValid,
        type: "black",
      },
      { name: "cancel", action: leftNavigation, type: "grey" },
    ];
    return actions;
  };

  const getNavigation = () => {
    return {
      title: "Add Bank Account",
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const getContent = () => {
    return <GSForm formTitle="Payment Settings" formSections={getBankAccountForm(context, selectedBankAccount)}></GSForm>;
  };
  
  const getDrawer = () => {
    return {
      actions: getActions(),
    };
  };

  const timeoutAction = () => {
    dispatch(clearNotifications());
  };

  const getBannerActions = () => {
    return [
      {
        id: 1,
        title: "Back to details",
        size: "secondary",
        actionClick: leftNavigation,
      },
    ];
  };

  const [banner] = useNotificationBanner(
    {
      notifications: orgNotifications.map((n) => ({
      ...n,
      pageActions: getBannerActions(),
    })), timeoutAction});

  return (
    <add-bank-account>
      <GSSidePanelPage
        header={getNavigation()}
        banner={banner}
        content={getContent()}
        drawer={getDrawer()}
      />
    </add-bank-account>
  );
};

export default AddBankAccount;
